var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmartphoneOutline = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.18 3.9h1.64c1.094 0 1.806.001 2.35.046.522.042.728.116.838.172a2 2 0 0 1 .874.874c.056.11.13.316.172.839.045.543.046 1.255.046 2.349v7.64c0 1.094-.001 1.806-.046 2.35-.042.522-.116.728-.172.838a2 2 0 0 1-.874.874c-.11.056-.316.13-.839.172-.543.045-1.255.046-2.349.046h-1.64c-1.094 0-1.806-.001-2.35-.046-.522-.042-.728-.116-.838-.172a2 2 0 0 1-.874-.874c-.056-.11-.13-.316-.172-.839-.045-.543-.046-1.255-.046-2.349V8.18c0-1.094.001-1.806.046-2.35.042-.522.116-.728.172-.838a2 2 0 0 1 .874-.874c.11-.056.316-.13.839-.172.543-.045 1.255-.046 2.349-.046ZM5.1 8.18c0-2.128 0-3.192.414-4.005a3.8 3.8 0 0 1 1.66-1.66C7.989 2.1 9.053 2.1 11.18 2.1h1.64c2.128 0 3.192 0 4.005.414a3.8 3.8 0 0 1 1.66 1.66c.415.814.415 1.878.415 4.006v7.64c0 2.128 0 3.192-.414 4.005a3.8 3.8 0 0 1-1.66 1.66c-.814.415-1.878.415-4.006.415h-1.64c-2.128 0-3.192 0-4.005-.414a3.8 3.8 0 0 1-1.66-1.66C5.1 19.011 5.1 17.947 5.1 15.82V8.18Zm6.15 8.02a.9.9 0 1 0 0 1.8h1.5a.9.9 0 0 0 0-1.8h-1.5Z",
    fill: "currentColor"
  })));
};
export default SvgSmartphoneOutline;